import * as BeaconComponentRegistryListener from '../search/communicationChannelListeners/BeaconComponentRegistryListener';
import * as FeatureFlagListener from '../search/communicationChannelListeners/FeatureFlagListener';
import * as SessionManagementListener from '../search/communicationChannelListeners/SessionManagementListener';
import * as TelemetryListener from '../search/communicationChannelListeners/TelemetryListener';

export function listenToCommonCommunicationChannels() {
    FeatureFlagListener.startListening();
    SessionManagementListener.startListening();
    TelemetryListener.startListening();
    BeaconComponentRegistryListener.startListening();
}